import { render } from "./VentasDespachosView.vue?vue&type=template&id=3a57aeb4"
import script from "./VentasDespachosView.vue?vue&type=script&lang=js"
export * from "./VentasDespachosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__